<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid">
    <div class="row signup-page standard_reg whiteandround">
      <div class="col-lg-12">
        <div class="signup-page--right">
          <div class="form-help">
            <div class="row inner_logo">
              <img :src="getTranslations.logo_for_branded_projects || 'static/images/logo.svg'"
                   alt="">
            </div>
            <span>{{ getTranslations.visitor_forgot_password_1_recover_your_password }}</span>
          </div>
          <div class="col-lg-12">
            <div class="StandardRegSteps_Container" v-if="!hasStepsToDisplay">
              <div class="StandardRegSteps_step">1</div>
              <div class="StandardRegSteps_step inactive">2</div>
              <div class="StandardRegSteps_step inactive">3</div>
            </div>
          </div>
          <div class="signup-form">
            <div class="form-help">
              <img class="form-help__icon"
                   src="static/images/keypad-icon.svg"
                   alt="">
              <h1>{{ getTranslations.visitor_forgot_password_1_forgot_your_pin }}</h1>
              <p>{{ getTranslations.visitor_forgot_password_1_please_enter }}</p>
            </div>
            <div v-if="multiOperatorInfo.multiOperatorEnabled" class="operators_selection_wrap ">
              <h1>{{ getTranslations.home_modals_select_operator_my_operator_is }}</h1>
              <div class="operators_radio">
                <label v-for="(op, index) in multiOperatorInfo.multiOperatorKeys"
                       :key="index"
                       class="operators_radio operators_radio_inline">
                  <img class="operators_icon"
                       :src="getOperatorImage(index)"
                       :alt="getOperatorDisplayName(index)">
                  <input type="radio"
                         name="operator"
                         @click="onOperatorSelect(op)"
                         :value="op">
                  <span></span>
                </label>
              </div>
              <div class="form-group form-group--icon fb_login has-warning operators_error_msg"
                   v-if="noOperatorSelected && user.operator==''">
                  <span class="form-group__feedback">
                    {{ getTranslations.visitor_sign_up_1_single_country_select_operator }}
                  </span>
              </div>
            </div>
            <form action="">
              <div :class="[ 'form-group', !hasErrors ? '' : 'has-warning' ]">
                <input type="number"
                       :placeholder="getTranslations.visitor_forgot_password_1_enter_mobile_number"
                       class="form-group__textfield phone_input"
                       @keyup="check"
                       v-model="user.msisdn">
                <span class="form-group__feedback"
                      v-show="getMessage(message) && user.msisdn">
                  {{ getMessage(message) }}
                </span>
              </div>
              <button type="submit"
                      :class="['btn btn--medium btn--main', ( hasErrors ? 'deactivated' : '')]"
                      @click.prevent="checkButton">
                {{ getTranslations.visitor_forgot_password_1_submit_button_continue }}
              </button>
              <!--ADD CLASS "deactivated" IF "has-warning" IS ACTIVE AS WELL ABOVE-->
              <!--span class="form-group__code">$#You need a new unique code? <a href="#">$#Resend me a code</a></span-->
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';

export default {
  name: 'forgotPassword1',
  mixins: [RegistrationFlowMixin],
  data() {
    return {
      user: {
        msisdn: '',
        operator: '',
      },
      message: '',
      hasErrors: false,
      hasStepsToDisplay: false,
      noOperatorSelected: false,
    };
  },
  created() {
    this.hasStepsToDisplay = this.hasSimplify();
  },
  methods: {
    ...mapMutations('profile', [
      'setForgotPasswordInfo',
    ]),
    getOperatorDisplayName(operatorIndex) {
      return this.multiOperatorInfo.multiOperatorDisplayNames[operatorIndex];
    },
    getOperatorImage(operatorIndex) {
      return this.getTranslationByOperator(operatorIndex, 'visitor_sign_up_1_operator_image');
    },
    onOperatorSelect(operator) {
      this.user.operator = operator;
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    clearData() {
      this.user.msisdn = '';
      this.message = '';
      this.hasErrors = false;
    },
    check() {
      const validMsisdnRegex = /^[0-9]{0,20}$/;
      const validMsisdn = this.user.msisdn.match(validMsisdnRegex);
      if (!validMsisdn) {
        this.message = 'visitor_forgot_password_invalid_msisdn_msg';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    checkButton() {
      if (this.multiOperatorInfo.multiOperatorEnabled && this.user.operator === '') {
        this.noOperatorSelected = true;
        this.hasErrors = true;
      }
      if (!this.hasErrors) {
        this.message = '';
        this.$axios.get(`api/requestNewPin?msisdn=${this.user.msisdn}&lang=${this.getLocale}&operator=${this.user.operator}`).then((response) => {
          const res = response.data.responseEnum;
          if (res === 'OPERATION_SUCCESS') {
            this.setForgotPasswordInfo(response.data.data);
            this.getNextForgotPasswordStep()();
            this.user.msisdn = '';
            this.message = '';
          } else {
            if (res === 'MSISDN_INVALID') {
              this.message = 'visitor_forgot_password_invalid_msisdn_msg';
            } else if (res === 'ALREADY_REGISTERED') {
              this.message = 'visitor_forgot_password_msisdn_already_registered';
            } else if (res === 'MSISDN_NOT_EXIST') {
              this.message = 'visitor_forgot_password_msisdn_not_exists';
            } else if (res === 'MSISDN_BLACKLISTED') {
              this.message = 'visitor_forgot_password_msisdn_blacklisted';
            } else if (res === 'SERVER_ERROR') {
              this.message = 'home_profile_profile_edit_server_unvailable';
            } else if (res === 'BLOCKED_USER') {
              this.message = 'visitor_forgot_password_warning_msd_max_attempts';
            } else if (res === 'CAMPAIGN_CLOSED') {
              this.message = 'visitor_sign_up_campaign_closed';
            } else if ((res === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (res === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (res === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
              this.message = 'visitor_sign_up_warning_third_party_error';
            }
            this.hasErrors = true;
          }
        });
      } else {
        this.message = 'visitor_forgot_password_invalid_msisdn_msg';
        this.hasErrors = true;
      }
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/forgotPassword/ForgotPassword1.vue